import React from "react";
import "./css/scheduleTable.css";

function ScheduleTable() {
  return (
    <div className="neumorphicWrapper">
      <div className="neumorphicContainer">
        <table className="neumorphic">
          <thead>
            <tr>
              <th>Monday</th>
              <th>Tuesday</th>
              <th>Wednesday</th>
              <th>Thursday</th>
              <th>Friday</th>
              <th>Saturday</th>
              <th>Sunday</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>6:00pm - 7:30pm</td>
              <td>6:00pm - 7:30pm</td>
              <td>6:00pm - 7:30pm</td>
              <td>6:00pm - 7:30pm</td>
              <td>No Class</td>
              <td>No Class</td>
              <td>No Class</td>
            </tr>
            <tr>
              <td>6:00pm - 7:30pm</td>
              <td>6:00pm - 7:30pm</td>
              <td>6:00pm - 7:30pm</td>
              <td>6:00pm - 7:30pm</td>
              <td>No Class</td>
              <td>No Class</td>
              <td>No Class</td>
            </tr>
            <tr>
              <td>6:00pm - 7:30pm</td>
              <td>6:00pm - 7:30pm</td>
              <td>6:00pm - 7:30pm</td>
              <td>6:00pm - 7:30pm</td>
              <td>No Class</td>
              <td>No Class</td>
              <td>No Class</td>
            </tr>
            <tr>
              <td>6:00pm - 7:30pm</td>
              <td>6:00pm - 7:30pm</td>
              <td>6:00pm - 7:30pm</td>
              <td>6:00pm - 7:30pm</td>
              <td>No Class</td>
              <td>No Class</td>
              <td>No Class</td>
            </tr>
            <tr>
              <td>6:00pm - 7:30pm</td>
              <td>6:00pm - 7:30pm</td>
              <td>6:00pm - 7:30pm</td>
              <td>6:00pm - 7:30pm</td>
              <td>No Class</td>
              <td>No Class</td>
              <td>No Class</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ScheduleTable;
